import getRole from "./RoleService";

const uri = `${import.meta.env.VITE_BASE_URL}/api`;

const CreatePost = async (
  foundation,
  imageResult,
  linkResult,
  note,
  active,
  isValid,
  reasonNoneValid,
  image64
) => {
  try {
    const role = await getRole();
    const formData = new FormData();
    formData.append("foundation", foundation);
    formData.append("imageResult", imageResult);
    formData.append("linkResult", linkResult);
    formData.append("note", note);
    formData.append("active", active);
    formData.append("isValid", isValid);
    formData.append("reasonNoneValid", reasonNoneValid);
    formData.append("image64", image64.toString());
    if (role) {
      const { token } = role;
      const response = await fetch(`${uri}/post-result`, {
        method: "post",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });
      if (response.status === 200) {
        const data = await response.json();
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Client Error" };
  }
};

const UpdatePost = async (
  idPost,
  foundation,
  linkResult,
  note,
  active,
  isValid,
  reasonNoneValid
) => {
  try {
    const role = await getRole();
    const formData = new FormData();
    formData.append("idPost", idPost);
    formData.append("foundation", foundation);
    formData.append("linkResult", linkResult);
    formData.append("note", note);
    formData.append("active", active);
    formData.append("isValid", isValid);
    formData.append("reasonNoneValid", reasonNoneValid);
    if (role) {
      const { token } = role;

      const response = await fetch(`${uri}/post-result/update`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Client Error" };
  }
};

const AcceptPost = async (idPost) => {
  try {
    const role = await getRole();
    const formData = new FormData();
    formData.append("idPost", idPost);
    if (role) {
      const { token } = role;

      const response = await fetch(`${uri}/post-result/accept`, {
        method: "post",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Client Error" };
  }
};

const RejectPost = async (idPost, reason) => {
  try {
    const role = await getRole();
    const formData = new FormData();
    formData.append("idPost", idPost);
    formData.append("reason", reason);
    if (role) {
      const { token } = role;

      const response = await fetch(`${uri}/post-result/reject`, {
        method: "post",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Client Error" };
  }
};

const CancelPost = async (idPost) => {
  try {
    const role = await getRole();
    const formData = new FormData();
    formData.append("idPost", idPost);
    if (role) {
      const { token } = role;

      const response = await fetch(`${uri}/post-result/cancel`, {
        method: "post",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Client Error" };
  }
};

const DeletePost = async (idPost) => {
  try {
    const role = await getRole();
    const formData = new FormData();
    formData.append("idPost", idPost);
    if (role) {
      const { token } = role;

      const response = await fetch(`${uri}/post-result/delete`, {
        method: "post",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Client Error" };
  }
};

const UpdateImage = async (idPost, image) => {
  try {
    const role = await getRole();
    const formData = new FormData();
    formData.append("idPost", idPost);
    formData.append("image", image);
    if (role) {
      const { token } = role;

      const response = await fetch(`${uri}/post-result/reject`, {
        method: "post",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Client Error" };
  }
};

const GetAllPostByUser = async (
  page,
  num_row,
  creator,
  foundation,
  status,
  linkResult,
  createdAtFrom,
  createdAtTo
) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;
      const active = 1;
      const queryParams = new URLSearchParams({
        page,
        num_row,
        creator,
        active,
        status,
        foundation,
        status,
        linkResult,
        createdAtFrom,
        createdAtTo,
      }).toString();

      const response = await fetch(
        `${uri}/post-result/get-all?${queryParams}`,
        {
          method: "get",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Client Error" };
  }
};

const getUserStats = async (days, startDate, endDate) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;
      const queryParams = new URLSearchParams({
        days,
        startDate,
        endDate,
      }).toString();
      const response = await fetch(
        `${uri}/post-result/user-stats?${queryParams}`,
        {
          method: "get",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Client Error" };
  }
};
export {
  CreatePost,
  UpdatePost,
  AcceptPost,
  RejectPost,
  CancelPost,
  UpdateImage,
  DeletePost,
  GetAllPostByUser,
  getUserStats,
};
